// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CheckboxToggleController from "./checkbox_toggle_controller"
application.register("checkbox-toggle", CheckboxToggleController)

import LocalStorageController from "./local_storage_controller"
application.register("local-storage", LocalStorageController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import ScrollIntoViewController from "./scroll_into_view_controller"
application.register("scroll-into-view", ScrollIntoViewController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import TextAreaController from "./text_area_controller"
application.register("text-area", TextAreaController)
